export default __webpack_public_path__ + "static/media/airdockz-bpk-2.90ff9dbb.png";